import { authService } from '../services/authService';
import { canAccessApprenantPortal } from './authRouting';
import { setPendingFiliereSubscription } from './pendingFiliereSubscription';

/**
 * Lance la souscription à une formation (public) : mémorise la filière, puis login ou écran de préparation paiement.
 * @param {(path: string) => void} navigate
 * @param {{ id: string; code: string }} filiere
 */
export function goToFormationSubscribe(navigate, filiere) {
  if (!filiere?.id) return;
  setPendingFiliereSubscription(filiere.id);
  const auth = authService.getStoredAuth();
  if (canAccessApprenantPortal(auth?.user?.role)) {
    navigate(`/app/formations/subscribe/${filiere.id}`);
    return;
  }
  navigate(`/login?mode=register&filiere=${encodeURIComponent(filiere.code)}`);
}
